import { isFeatureEnabled } from 'owa-feature-flags';

export function isLocalBootAvailable(): boolean {
    return isFeatureEnabled('fwk-local-boot');
}
